<p>
  При създаване на обява в платформата е <strong>задължително да посочите населено място</strong>. Това позволява на
  другите потребители да преценят възможностите за <strong>лична среща</strong> или да се ориентират относно
  <strong>времето и разходите по доставката</strong>.
</p>
<p>
  За по-голямо удобство може да зададете <strong>населено място по подразбиране</strong>, което автоматично ще се
  попълва при създаване на нови обяви. Това спестява време и елиминира необходимостта от ръчно въвеждане при всяка
  публикация.
</p>
<h6 class="mt-3">Как да зададете или смените адреса по подразбиране:</h6>
<ol>
  <li>Отворете <strong>„Профил“</strong> от горната навигация и изберете <strong>„Настройки“</strong>.</li>
  <li>В секцията <strong>„Настройки на профила“</strong> намерете реда <strong>„Адрес по подразбиране“</strong> и
    натиснете бутона <strong>„Промени“</strong>.
  </li>
  <li>
    В отворилия се прозорец изберете:
    <ul>
      <li><strong>Област</strong></li>
      <li><strong>Община</strong></li>
      <li><strong>Населено място</strong></li>
    </ul>
  </li>
  <li>Натиснете <strong>„Запази“</strong>, за да приложите промените.</li>
</ol>
<h6 class="mt-3">Алтернативен начин:</h6>
<p>
  Можете да зададете адрес по подразбиране и директно при създаване или редактиране на обява – като маркирате полето
  <strong>„Запази като адрес по подразбиране“</strong> под избора на населено място. Така въведеният адрес ще се
  използва автоматично и за бъдещи обяви.
</p>
<h6 class="mt-3">Какво се случва след това?</h6>
<p>
  Посоченото населено място ще се попълва автоматично при създаване на нови обяви. При необходимост, може да го
  променяте ръчно за всяка конкретна обява.
</p>
<div class="alert alert-primary m-0">
  <strong>Съвет:</strong> Ако често публикувате обяви от различни градове (например пътувате или изпращате от различни
  офиси), актуализирайте адреса си по подразбиране според текущото ви местоположение.
</div>
